import PropTypes from "prop-types";

export const InterventionDissociateField = PropTypes.oneOf(["project_id"]);

// TODO when migrate this file to TS, remove `@ts-expect-error`
// in `interventions-list-table-row-actions.component.tsx` file
const commonProps = {
  dissociateField: InterventionDissociateField.isRequired,
  dissociateModel: PropTypes.object.isRequired,
  invalidateKeys: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};

export const InterventionDissociateProps = {
  ...commonProps,
  interventionModel: PropTypes.object.isRequired,
};

export const InterventionsBatchDissociateProps = {
  ...commonProps,
  interventionsModels: PropTypes.arrayOf(PropTypes.object).isRequired,
};
